import React from 'react';
import './css/NotFound.css';

const NotFound = () => {
    return (
        <div className="not-found">
            <h2>404 - Page Not Found</h2>
            <p>Oops! Either your internet is on a coffee break or you're simply dumb!</p>
            <a href="/">Go back to Home</a>
        </div>
    );
};

export default NotFound;
